import { render, staticRenderFns } from "./PayRiskManagementDetail.vue?vue&type=template&id=0ea378f8&"
import script from "./PayRiskManagementDetail.vue?vue&type=script&lang=js&"
export * from "./PayRiskManagementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports